import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { OfferImage } from '../types/offers'

export interface ToteItem {
  offerId: string
  title: string
  streamName: string
  streamSlug?: string
  streamAvatarUrl?: string
  streamDescription?: string
  streamSince?: number
  drops: number
  imageUrl?: string
  images?: OfferImage[]
}

interface ToteState {
  items: ToteItem[]
  isOpen: boolean
  addItem: (item: ToteItem) => void
  removeItem: (offerId: string) => void
  clearTote: () => void
  openTote: () => void
  closeTote: () => void
}

export const useToteStore = create<ToteState>()(
  persist(
    (set) => ({
      items: [],
      isOpen: false,
      addItem: (item) =>
        set((state) => ({
          items: state.items.some((i) => i.offerId === item.offerId)
            ? state.items
            : [...state.items, item],
        })),
      removeItem: (offerId) =>
        set((state) => ({ items: state.items.filter((i) => i.offerId !== offerId) })),
      clearTote: () => set({ items: [] }),
      openTote: () => set({ isOpen: true }),
      closeTote: () => set({ isOpen: false }),
    }),
    {
      name: 'swim-tote',
      partialize: (state) => ({ items: state.items }),
    }
  )
)
